<template>

  <memlist-card>
    <div class="d-flex justify-end">
      <memlist-icon-button
        class="mb-2"
        icon="menu-icon flaticon2-plus"
        :text="$t('PAGES.MEMBER_PROPERTY.NEW_ATTRIBUTE')"
        variant="primary"
        @click="create_member_property_clicked"
      />
    </div>

    <MemberPropertyEditorModal
      ref="edit-prop"
      :group_id="group_id"
      :prop_id="selected_prop_id"
      @created="created_prop"
      @updated="updated_prop"
    />

    <memlist-static-table
      id="stickprov-table"
      :fields="headers"
      :items="properties"
    >
      <template #cell(action)='row'>
        <div class='d-flex justify-content-end'>
          <a
            href="#"
            class="btn btn-icon btn-light btn-sm mx-3"
            @click.prevent="selectGroupAttributeClicked(row.item.prop_id)"
          >
            <span class="svg-icon svg-icon-md svg-icon-primary">
              <!--begin::Svg Icon-->
              <inline-svg src="/assets/svg/pencil-square.svg"></inline-svg>
              <!--end::Svg Icon-->
            </span>
          </a>
          <a
            href="#"
            class="btn btn-icon btn-light btn-sm"
            @click.prevent="deleteGroupAttributeClicked(row.item.prop_id)"
          >
            <span class="svg-icon svg-icon-md svg-icon-primary">
              <!--begin::Svg Icon-->
              <inline-svg src="/assets/svg/trash2.svg"></inline-svg>
              <!--end::Svg Icon-->
            </span>
          </a>
        </div>
      </template>
    </memlist-static-table>


  </memlist-card>

</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import RightSaveButton from '@/view/components/buttons/RightSaveButton.vue';
import MemberPropertyEditorModal from './MemberPropertyEditorModal.vue';

export default {
  name: 'MemberPropertyTable',
  mixins: [validationMixin, toasts],
  computed: {
    disabled_button() {
      return this.form.name === '';
    },

    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'companies'])
  },
  props: ['group_id'],
  emits: ['deleteGroupAttributeClicked'],
  components: {
    RightSaveButton,
    MemberPropertyEditorModal
  },
  mounted() {

    this.load_attributes();
  },
  watch: {
    group_id(newValue, oldvalue) {
      this.creating = false;
      this.editing = false;
      this.load_attributes();
    }
  },
  methods: {

    created_prop(prop) {
      this.properties.unshift(prop);
      this.selected_prop_id = prop.prop_id;
    },
    updated_prop(prop) {
      const index = this.properties.findIndex(i => i.prop_id === prop.prop_id);

      if (index >= 0) {
        this.properties[index] = prop;
        this.properties = [...prop];
      }
    },

    async create_member_property_clicked() {
      this.selected_prop_id = null;
      
      this.$nextTick(()=>{
        this.$refs['edit-prop'].show();
      });
      
    },
    
    async load_attributes() {
      try {
        if (!this.group_id) {
          return;
        }

        this.properties = [];

        const res = await axios.get(`/member_property?group_id=${this.group_id}`)
        if (res.status === 200) {
          this.properties = res.data;
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ATTRIBUTE.UNABLE_LIST'));
        }
      }
      catch (err) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ATTRIBUTE.UNABLE_LIST'));
      }
    },
    selectGroupAttributeClicked(prop_id) {
      this.selected_prop_id = prop_id;
      this.$nextTick(()=>{
        this.$refs['edit-prop'].show();
      });
    },
    
    deleteGroupAttributeClicked(prop_id) {
      axios
        .delete(`/member_property/${prop_id}`)
        .then(res => {
          this.properties = this.properties.filter(item => item.prop_id !== prop_id);

          this.creating = false;
          this.editing = false;

          this.toastr('success', this.$t('COMMON.OK'), this.$t('ATTRIBUTE.DELETED'));
        })
        .catch(err => {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ATTRIBUTE.UNABLE_DELETE'));
        });

      this.$emit('deleteGroupAttributeClicked', prop_id);
    },
    scrollToEditGroup() {
      var that = this;
      setTimeout(function () {
        const el = that.$el.getElementsByClassName('scroll-to-attributes')[0];

        if (el) {
          const yOffset = -70;
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },
  data() {
    return {
      selected_prop_id: null,
      properties: [],
      headers: [
        {
          key: 'name',
          label: this.$t('MEMBER.ATTRIBUTE'),
          sortable: true,
          thClass: 'pl-7 w-100',
          tdClass: 'pl-7 align-middle'
        },
        {
          key: 'action',
          label: '',
          thClass: 'w-110px',
          tdClass: 'align-middle'
        },
      ],
      list: [],
      form: {
        prop_id: '',
        name: '',
        descr: '',
        company_id: null,
        period_id: null
      },
      creating: false,
      editing: false
    };
  },
  validations: {
    form: {
      name: { required, minLength: minLength(1) }
    }
  },
};
</script>
